const SpotahomeGuaranteeCircledIcon = ({ size = '40', ...restProps }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <circle cx="16" cy="16" r="16" fill="#E3F0FB" />
    <path
      d="M11.7536 16.1937L14.7786 18.7812L20.3964 13.6062M7 8V17.9C7 22.912 11.063 26.975 16.075 26.975C21.087 26.975 25.15 22.912 25.15 17.9V8H7Z"
      stroke="black"
      strokeWidth="1.2"
    />
  </svg>
);

export default SpotahomeGuaranteeCircledIcon;
